import React from 'react';

import {AcademicYearChangeModal} from '../../components/academic-year-change-modal/academic-year-change-modal';
import {SearchTableContainer} from '../search-table/search-table-container';
import {useAcademicYearChangeModal} from './hooks/use-academic-year-change-modal';

export const HomeContainer = () => {
    const {
        onClose, onSubmitChangeEndDate,
        isLoading, school, isOpen,
        onOpenChangeSchool
    } = useAcademicYearChangeModal();

    return (
        <>
            <AcademicYearChangeModal
                isLoading={isLoading}
                school={school}
                open={isOpen}
                onClose={onClose}
                onSubmitChangeEndDate={onSubmitChangeEndDate}
            />

            <SearchTableContainer
                onOpenChangeSchool={onOpenChangeSchool}
            />
        </>
    );
};
